import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { projectDataClient } from '../../../../lib/connect/clients';
const PROPOSAL_RFI_KEY = 'proposal-rfi-responses';
export function useListRfiResponsesForProposal(proposalProjectId) {
    return useQuery({
        queryKey: [
            PROPOSAL_RFI_KEY,
            proposalProjectId
        ],
        enabled: Boolean(proposalProjectId),
        queryFn: async ()=>{
            const resp = await projectDataClient.listRfiResponsesForProposal({
                proposalProjectId
            });
            return resp;
        }
    });
}
export function useLinkRfiResponseToProposal() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (args)=>{
            const resp = await projectDataClient.linkRfiResponseToProposal({
                proposalProjectId: args.proposalProjectId,
                rfiResponseProjectId: args.rfiResponseProjectId
            });
            return resp.link;
        },
        onSuccess: (_data, vars)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    PROPOSAL_RFI_KEY,
                    vars.proposalProjectId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'linked-nodes'
                ]
            });
        },
        onError: (err)=>{
            toast.error(err instanceof Error ? err.message : 'Failed to link RFI Response');
        }
    });
}
export function useUnlinkRfiResponseFromProposal() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (args)=>{
            await projectDataClient.unlinkRfiResponseFromProposal({
                proposalProjectId: args.proposalProjectId,
                rfiResponseProjectId: args.rfiResponseProjectId
            });
        },
        onSuccess: (_data, vars)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    PROPOSAL_RFI_KEY,
                    vars.proposalProjectId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'linked-nodes'
                ]
            });
        },
        onError: (err)=>{
            toast.error(err instanceof Error ? err.message : 'Failed to unlink RFI Response');
        }
    });
}
